import { createSelector } from 'reselect';
import type { AppState } from '../../../types/State';
import type { RadioConfigurationState } from '../reducers/radioConfigurationReducer';

const getRadioConfigurationState = (state: AppState): RadioConfigurationState => state.radioConfiguration;
export const isFetching = createSelector([getRadioConfigurationState], state => state.fetching);
export const getError = createSelector([getRadioConfigurationState], state => state.error);
export const getStep = createSelector([getRadioConfigurationState], state => state.step);
export const getStatsRadioPlayerData = createSelector([getRadioConfigurationState], state => state.statsRadioPlayer);



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/selectors/radioConfigurationSelectors.js